module.exports = __webpack_public_path__ + "static/media/sco.bdb38530.svg";